var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 425.177,
    height: 364.768,
    viewBox: "0 0 425.177 364.768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M3885.475,1504.14s1.331,86.29,28.582,107.841h66.756s11.153-80.943-19.564-102.738Z",
    transform: "translate(-3885.475 -1504.14)",
    fill: "#1b3d9e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M3718.477,964.391s-49.039,26.843-64.32,37.836c-27.578,19.839,3.364-58.812-1.564-62.175s-40.212-3.807-45.45,5.745-20.3,107.632,15.752,105.167,73.785-19.774,73.785-19.774S3727.429,979.559,3718.477,964.391Z",
    transform: "translate(-3599.535 -937.87)",
    fill: "#f9c438"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M3947.954,997.831s38.62,33.865,36.3,55.668-23.195,98.811-30.617,102.522-68.045,9.278-75.774-5.1-.77-110.872,9.436-126.645,31.094-20.872,31.094-20.872Z",
    transform: "translate(-3874.564 -997.831)",
    fill: "#f9c438"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M3947.4,742.628a52.83,52.83,0,0,0-10.949,2.179,17.735,17.735,0,0,0-8.948,6.392c-3.049,4.486-3.082,10.385-5.482,15.249-2.975,6.027-9.254,9.851-12.453,15.763a16.426,16.426,0,0,0-1.782,10.876c.992,5.023,4.585,9.242,8.88,12.027s9.271,4.315,14.221,5.625a204.887,204.887,0,0,0,30.242,5.611,189.656,189.656,0,0,0,9.21-26.256c3.076-11.045,5.1-23.062,1.058-33.793a21.45,21.45,0,0,0-4.739-7.726C3961.978,743.909,3953.964,741.8,3947.4,742.628Z",
    transform: "translate(-3907.511 -742.452)",
    fill: "#1b3d9e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M4003.648,764.086c-2.678-5.041-14.839-12.583-25.912-12.924a15.581,15.581,0,0,0-14.558,9.173c-5.886,12.851-18.68,43.418-9.719,48.433,3.989,2.233,9.24,2.317,14.531,1.269-.82,8.427-1.023,27.977-.867,30.632.219,3.731,26.239-3.026,31.068-6.538s-8.13-35.185-8.13-35.185C3993.567,793.89,4007.373,771.1,4003.648,764.086Z",
    transform: "translate(-3950.369 -751.155)",
    fill: "#fe8e9c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M4046.8,757.677c1.6,3.477,4.717,6.074,6.336,9.54,2.833,6.066.512,13.127-1.115,19.621-2.359,9.414-2.984,20.032,2.236,28.214,3.379,5.3,8.9,8.974,14.832,11.052s12.273,2.673,18.553,2.82a137.227,137.227,0,0,0,40.792-5.221c-2.823-1.081-5.795-2.27-7.633-4.672-2.355-3.081-2.245-7.3-2.338-11.182a50.922,50.922,0,0,0-3.729-18.86,31.751,31.751,0,0,0-12.16-14.65c-4.1-2.521-9-4.016-12.129-7.671-3.5-4.085-3.957-9.85-5.183-15.087a46.472,46.472,0,0,0-4.882-12.424c-1.52-2.662-3.434-5.284-6.217-6.568-2.633-1.215-5.689-1.063-8.542-.549-9.709,1.749-18.394,7.493-19.838,18.028A13.75,13.75,0,0,0,4046.8,757.677Z",
    transform: "translate(-4045.641 -731.657)",
    fill: "#1b3d9e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M3696.451,850.907s-22.684,33.38-17.3,37.173,12.508,5.01,13.586,2.915,14.884-38.822,14.884-38.822Z",
    transform: "translate(-3678.327 -850.907)",
    fill: "#1b3d9e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M3605.5,723.963a4.978,4.978,0,0,0-2-5.646c-14.7-9.737-76.427-50.4-80.124-49.1-4.2,1.478-21.95,51.9-18.46,58.6,3.1,5.948,79.134.84,96.193-.384a4.976,4.976,0,0,0,4.39-3.469Z",
    transform: "translate(-3504.469 -669.189)",
    fill: "#68a9fd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 31.084,
    cy: 6.642,
    rx: 31.084,
    ry: 6.642,
    transform: "translate(0 59.295) rotate(-72.514)",
    fill: "#1b3d9e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M3954.83,1446.256s-16.084,5.6-20.612,8.93c0,0-22.9,14.769-19.617,16,1.806.677,8.458-2.535,14.076-5.562-3.074,7.361-6.134,16.075-4.688,15.754,2.321-.515,13.512-17.132,13.512-17.132s-7.5,19.108-6.31,19.141,8.7-6.136,10.723-17.351c0,0-2.267,15.748-.716,16.105s6.562-15.513,6.562-15.513,13.546-5.278,13.854-7.976S3954.83,1446.256,3954.83,1446.256Z",
    transform: "translate(-3914.279 -1446.256)",
    fill: "#fe8e9c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M3733.018,886.962s-13.687,4.577-13.063,5.949,10.667.385,10.667.385l-3.534,9.291a48.976,48.976,0,0,1,6.293.828s7.212-11.5,6.589-13.746S3733.018,886.962,3733.018,886.962Z",
    transform: "translate(-3719.934 -886.962)",
    fill: "#fe8e9c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15023",
    "data-name": "Group 15023",
    transform: "translate(-123 -279.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(205.673 279.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(120.91 254.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M3885.475,1504.14s1.331,86.29,28.582,107.841h66.756s11.153-80.943-19.564-102.738Z",
    transform: "translate(-3885.475 -1504.14)",
    fill: "#1b3d9e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M3973.486,1678.33c0-1.3-8.432-82.7-12-85.945s-2.595,85.621,1.622,86.594S3973.486,1678.33,3973.486,1678.33Z",
    transform: "translate(-3936.977 -1565.643)",
    fill: "#1c056d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(34.453 83.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M3718.477,964.391s-49.039,26.843-64.32,37.836c-27.578,19.839,3.364-58.812-1.564-62.175s-40.212-3.807-45.45,5.745-20.3,107.632,15.752,105.167,73.785-19.774,73.785-19.774S3727.429,979.559,3718.477,964.391Z",
    transform: "translate(-3599.535 -937.87)",
    fill: "#50ab32"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M3728.986,1120.855s-25.261,26.175-25.261,21.44,12.068-32.24,12.068-32.24,3.559,13.786,13.193,10.8",
    transform: "translate(-3672.222 -1057.993)",
    fill: "#f6ab36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M3659.663,934.745s-5.522,13.429-1.988,16.963,21.63,7.29,24.511,5.743,8.845-22.706,8.845-22.706S3668.5,931.7,3659.663,934.745Z",
    transform: "translate(-3639.271 -934.745)",
    fill: "#f6ab36"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(117.611 101.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M3947.954,997.831s38.62,33.865,36.3,55.668-23.195,98.811-30.617,102.522-68.045,9.278-75.774-5.1-.77-110.872,9.436-126.645,31.094-20.872,31.094-20.872Z",
    transform: "translate(-3874.564 -997.831)",
    fill: "#50ab32"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M3861.263,1277.52s41.486,19.393,104.533,12.207l-1.307,12.087s-84.933,6.3-106.82-14.162Z",
    transform: "translate(-3862.778 -1192.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M3858.39,1358.477s40.25,14.575,86.7,11.121l-2.644,9.4s-61.488,5.332-85.657-11.729Z",
    transform: "translate(-3862.167 -1249.432)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M3852.274,1163.169s2.33-24.494,9.47-43.023c0,0-19.362,18.182-22.358,47.583C3839.386,1167.729,3845.9,1165.347,3852.274,1163.169Z",
    transform: "translate(-3732.412 -981.756)",
    fill: "#f6ab36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M3998.679,1029.259s-.392,3.436.822,3.674,15.776-.59,30.293-7.349l2.933,1.777s-19.992,10.608-31.212,9.267S3998.679,1029.259,3998.679,1029.259Z",
    transform: "translate(-3841.442 -915.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(127.572 11.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0 12.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M3947.4,742.628a52.83,52.83,0,0,0-10.949,2.179,17.735,17.735,0,0,0-8.948,6.392c-3.049,4.486-3.082,10.385-5.482,15.249-2.975,6.027-9.254,9.851-12.453,15.763a16.426,16.426,0,0,0-1.782,10.876c.992,5.023,4.585,9.242,8.88,12.027s9.271,4.315,14.221,5.625a204.887,204.887,0,0,0,30.242,5.611,189.656,189.656,0,0,0,9.21-26.256c3.076-11.045,5.1-23.062,1.058-33.793a21.45,21.45,0,0,0-4.739-7.726C3961.978,743.909,3953.964,741.8,3947.4,742.628Z",
    transform: "translate(-3907.511 -742.452)",
    fill: "#1b3d9e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M3948.354,787.7s-21.318,37.157-8.038,47.415,26.956-1.9,26.956-1.9l2.009-46.877Z",
    transform: "translate(-3927.358 -773.069)",
    fill: "#1c056d",
    opacity: 0.24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(12.958 14.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M4003.648,764.086c-2.678-5.041-14.839-12.583-25.912-12.924a15.581,15.581,0,0,0-14.558,9.173c-5.886,12.851-18.68,43.418-9.719,48.433,3.989,2.233,9.24,2.317,14.531,1.269-.82,8.427-1.023,27.977-.867,30.632.219,3.731,26.239-3.026,31.068-6.538s-8.13-35.185-8.13-35.185C3993.567,793.89,4007.373,771.1,4003.648,764.086Z",
    transform: "translate(-3950.369 -751.155)",
    fill: "#fe8e9c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M4002.114,929.983a100.473,100.473,0,0,0,13.616-6.9s-5.475,17.564-16.449,17.111l2.833-10.213",
    transform: "translate(-3984.492 -871.101)",
    fill: "#e57492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M3967.214,774.779c.581-.133,5.1.8,13.328-5.975,0,0,3.054,4.382,13.278-1.859l1.593-8.5-21.113-2.789Z",
    transform: "translate(-3962.121 -754.297)",
    fill: "#e57492"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M3983.03,822.586s-14.5,7.971-13.45,10.073,11.349-.791,12.4-.265-2.088,3-3.5,2.91-11.262.158-11.262-2.483S3971.829,826.414,3983.03,822.586Z",
    transform: "translate(-3949.162 -786.147)",
    fill: "#e57492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M3974.935,882.8a17.043,17.043,0,0,0,14.7,0s-4.533,6.21-9.382,5.895C3973.855,888.278,3974.935,882.8,3974.935,882.8Z",
    transform: "translate(-3954.5 -828.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(41.764 8.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M4046.8,757.677c1.6,3.477,4.717,6.074,6.336,9.54,2.833,6.066.512,13.127-1.115,19.621-2.359,9.414-2.984,20.032,2.236,28.214,3.379,5.3,8.9,8.974,14.832,11.052s12.273,2.673,18.553,2.82a137.227,137.227,0,0,0,40.792-5.221c-2.823-1.081-5.795-2.27-7.633-4.672-2.355-3.081-2.245-7.3-2.338-11.182a50.922,50.922,0,0,0-3.729-18.86,31.751,31.751,0,0,0-12.16-14.65c-4.1-2.521-9-4.016-12.129-7.671-3.5-4.085-3.957-9.85-5.183-15.087a46.472,46.472,0,0,0-4.882-12.424c-1.52-2.662-3.434-5.284-6.217-6.568-2.633-1.215-5.689-1.063-8.542-.549-9.709,1.749-18.394,7.493-19.838,18.028A13.75,13.75,0,0,0,4046.8,757.677Z",
    transform: "translate(-4045.641 -731.657)",
    fill: "#1b3d9e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M4135.062,993.847s-43.978,21.283-68.644,6.779c0,0,19.774,24.576,53.955,18.927s35.028-10.53,35.028-10.53Z",
    transform: "translate(-4060.135 -914.572)",
    fill: "#1c056d",
    opacity: 0.24
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M3981.529,728.321a1.887,1.887,0,0,1-.779-.178,1.659,1.659,0,0,1-.522-1.9,7.051,7.051,0,0,0,.493-2.051c-3.752,4.9-10.023,7.21-16.128,8.128a.972.972,0,0,1-.89-.166.943.943,0,0,1-.17-.371,20.788,20.788,0,0,1,3.989-18.793,27.84,27.84,0,0,1,7.627-6.091c7.939-4.53,17.778-6.424,26.358-3.274a13.489,13.489,0,0,1,7.007,5.128,5.721,5.721,0,0,1,.971,3.069,6.256,6.256,0,0,1-2.4,4.364,16.935,16.935,0,0,1-5.448,3.053c-.982.359-1.988.63-2.984.947a3.391,3.391,0,0,0-1.584.95,25.077,25.077,0,0,1-3.857,3.78,18.326,18.326,0,0,1-5.228,2.629,17.364,17.364,0,0,1-5.785.808Q3981.863,728.346,3981.529,728.321Z",
    transform: "translate(-3946.059 -702.07)",
    fill: "#1b3d9e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(58.277 56.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M3696.451,850.907s-22.684,33.38-17.3,37.173,12.508,5.01,13.586,2.915,14.884-38.822,14.884-38.822Z",
    transform: "translate(-3678.327 -850.907)",
    fill: "#1b3d9e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M3710.644,856.171s19.608,1.954,20.331.314,2.6-7.909,2.6-7.909-20.852-5.9-21.6-3.975S3710.644,856.171,3710.644,856.171Z",
    transform: "translate(-3700.873 -846.238)",
    fill: "#1c056d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(5.709 2.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M3605.5,723.963a4.978,4.978,0,0,0-2-5.646c-14.7-9.737-76.427-50.4-80.124-49.1-4.2,1.478-21.95,51.9-18.46,58.6,3.1,5.948,79.134.84,96.193-.384a4.976,4.976,0,0,0,4.39-3.469Z",
    transform: "translate(-3504.469 -669.189)",
    fill: "#68a9fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M3766.346,785.425s4.226,14.467-7.8,30.668c0,0,28.516-2.666,29.519-5.847s3.273-6.118,1.845-8.3S3766.346,785.425,3766.346,785.425Z",
    transform: "translate(-3681.727 -750.28)",
    fill: "#1b3d9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M3498.293,808.772s20.035-4.212,38.463,6.055,54.493,5,54.493,5l-2.369,7.593s-73.711,8.715-84.5,6.089-10.038-18.415-6.082-24.739",
    transform: "translate(-3498.293 -765.971)",
    fill: "#1c056d",
    opacity: 0.24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 31.084,
    cy: 6.642,
    rx: 31.084,
    ry: 6.642,
    transform: "translate(0 59.295) rotate(-72.514)",
    fill: "#1b3d9e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M3536.96,754.779s-10.741-7.44-12.966-.58-2.1,9.272,11.414,10.526Z",
    transform: "translate(-3511.631 -724.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M3515.106,669.062s3.4,1.524,2.362,9.783c-.9,7.144-9.886,43.695-20.138,47.493,0,0,2.025,4.42,5.059,4.009s12.816-13.562,14.789-22,9.213-31.955,8.891-35.815S3517.185,665.323,3515.106,669.062Z",
    transform: "translate(-3493.78 -665.924)",
    fill: "#1c056d"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M4072.494,1495.653s-17.275,8.906-19.452,8.132-10.834-5.106-14.353-9.414c0,0-1.387,9.724,7.283,11.649,0,0,15.667-.559,22.108-3.592C4068.08,1502.427,4070.809,1501.405,4072.494,1495.653Z",
    transform: "translate(-3871.397 -1242.83)",
    fill: "#f6ab36"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(129.619 236.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M3954.83,1446.256s-16.084,5.6-20.612,8.93c0,0-22.9,14.769-19.617,16,1.806.677,8.458-2.535,14.076-5.562-3.074,7.361-6.134,16.075-4.688,15.754,2.321-.515,13.512-17.132,13.512-17.132s-7.5,19.108-6.31,19.141,8.7-6.136,10.723-17.351c0,0-2.267,15.748-.716,16.105s6.562-15.513,6.562-15.513,13.546-5.278,13.854-7.976S3954.83,1446.256,3954.83,1446.256Z",
    transform: "translate(-3914.279 -1446.256)",
    fill: "#fe8e9c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M3983.632,1446.358c-.14,1.256,10.75,12.177,18.98,12.177s8.985-5.627,8.985-5.627l-12.429-16.292S3983.884,1444.091,3983.632,1446.358Z",
    transform: "translate(-3962.662 -1439.531)",
    fill: "#e57492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M3915.339,1507.185s14.821-8.649,15.926-9.28-2.84,5.205-2.84,5.205-13.277,6.1-13.086,4.074",
    transform: "translate(-3915.017 -1482.255)",
    fill: "#e57492"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(160.793 130.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M4074.5,1098.182s45.91,59.926,42.594,75.772-72.965,54.907-78.861,53.433-22.328-12.555-20.745-23.966,51.7-46.419,51.7-46.419-26.609-17.32-25.465-31.323S4074.5,1098.182,4074.5,1098.182Z",
    transform: "translate(-4017.383 -1097)",
    fill: "#50ab32"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(1.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M4023.7,1262.842s33.091-31.546,49.9-42.393c0,0-18.6-7.917-25.465-31.323,0,0,1.357,30.384,15.853,32.317C4063.982,1221.442,4023.518,1247.221,4023.7,1262.842Z",
    transform: "translate(-4023.696 -1160.445)",
    fill: "#f6ab36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M4133.06,1094.271s-19.023,7.769-24.037,23.911C4109.023,1118.182,4106.159,1101.81,4133.06,1094.271Z",
    transform: "translate(-4083.162 -1094.271)",
    fill: "#f6ab36"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(60.897 67.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(9.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M3733.018,886.962s-13.687,4.577-13.063,5.949,10.667.385,10.667.385l-3.534,9.291a48.976,48.976,0,0,1,6.293.828s7.212-11.5,6.589-13.746S3733.018,886.962,3733.018,886.962Z",
    transform: "translate(-3719.934 -886.962)",
    fill: "#fe8e9c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M3744.58,917.774s4.135-12.148,3.521-12.046-4.693.749-4.693.749l-3.678,10.03Z",
    transform: "translate(-3733.745 -900.053)",
    fill: "#e57492"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M3722.005,899.676s6.954-1.027,7.755-2.4-5.453-1.817-5.453-1.817-5.439,3.217-4.583,3.746A4.8,4.8,0,0,0,3722.005,899.676Z",
    transform: "translate(-3719.724 -892.893)",
    fill: "#e57492"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M3699.416,895.83a3.277,3.277,0,0,1,1.6-.367c2.41.033,10.835.229,12.187,1.367,1.581,1.331-12.705,3.407-14.236,3.1C3697.607,899.652,3697.2,897.023,3699.416,895.83Z",
    transform: "translate(-3694.568 -892.893)",
    fill: "#fe8e9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M3703.342,910.039c-1.352-1.139-9.777-1.335-12.187-1.368a3.278,3.278,0,0,0-1.6.366,2.507,2.507,0,0,0-1.164,3.639c-2.021,1.234-1.607,3.727-.282,3.995,1.53.31,14.379-2.067,12.8-3.4-.728-.613-2.071-.651-4.858-.839C3700.1,911.771,3704.231,910.787,3703.342,910.039Z",
    transform: "translate(-3686.994 -902.107)",
    fill: "#fe8e9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M3699.269,915.59s-5.291,1.084-7.657.243c0,0,6.767-.581,9.624-1.176a47.149,47.149,0,0,0,5.328-1.462s.646.351-.908.935A62.037,62.037,0,0,1,3699.269,915.59Z",
    transform: "translate(-3690.215 -905.263)",
    fill: "#e57492"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17499",
    "data-name": "Rectangle 17499",
    width: 425.177,
    height: 2.147,
    transform: "translate(123 641.884)",
    fill: "#1b3d9e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/signIn.da85d83c23027a333dfcc0c3405895a5.svg";
export { ForwardRef as ReactComponent };